export default "__VITE_ASSET__BtnKkFpC__"